import { useCurrentUser } from '#app/hooks/useCurrentUser.js';

type SubscriptionFeature =
  | 'ADVANCED_CONTRACTOR_SEARCH'
  | 'BYPASS_PLATFORM_FEES'
  | 'CLIENT_ACCESS_BASIC_NETWORK'
  | 'CLIENT_ACCESS_NETWORK'
  | 'CLIENT_ANALYTICS'
  | 'CLIENT_COMPLIANT_CONTRACTS'
  | 'CLIENT_CUSTOM_CONTRACTS'
  | 'CLIENT_PUBLISH_NETWORK_LISTS'
  | 'CLIENT_WORKSPACE_DOCUMENT_UPLOAD'
  | 'SELF_SERVE_SUBSCRIPTION'
  | 'VIEW_CONTRACTOR_COMPLIANCE_DETAILS';

export const useSubscriptionFeature = (feature: SubscriptionFeature) => {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    return false;
  }

  return currentUser.workspaceForSelectedUserType.enabledFeatures.includes(
    feature,
  );
};
